@use "../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../styles/Constants.scss" as Constants;

$var-shadow: 0 2px 2px 0 Colors.$col-shadow;
$var-border: 1px solid Colors.$col-greyConnection;
$var-dot-icon-size: 6px;

.time-sheet-list {

	&__row {
		display: flex;
		flex-direction: column;
		box-shadow: $var-shadow;
		background: Colors.$col-white;
		margin-bottom: Constants.$val-spacing-s;

		&__name-and-action-section {
			padding-left: 24px;
			padding-right: 24px;
			padding-top: 8px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
		}

		&__info {
			border-radius: Constants.$val-borderRadius;
			padding-left: 18px;
			padding-right: 18px;
			display: flex;
			flex-direction: row;
			gap: Constants.$val-spacing-l;

			&__time-card-link {
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: Colors.$col-greyBackground;
				padding: Constants.$val-spacing-xs;
			}

			&__total-time-section {
				flex: 2;
			}

			&__info-section {
				padding: 8px;
				background-color: Colors.$col-greyLight;
			}

			&__no-icon {
				margin-left: Constants.$val-spacing-l;
			}

			&__edit {
				font-size: Constants.$val-fontSizeRegular;
				cursor: pointer;
				color: Colors.$col-design-blue500;
				padding-top: Constants.$val-spacing-xs;
				height: 26px;
				line-height: 26px;

				&:hover {
					color: Colors.$col-design-blue6;
				}

				&--owner {
					color: Colors.$col-blue;
				}
			}

			&--modified {
				background-color: Colors.$col-orangeHover;
			}

		}

		&__timeline-action {
			background-color: Colors.$col-white;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: row;
			border-bottom: 2px solid Colors.$col-greyBackground;

			&__button {
				color: Colors.$col-blue;
				cursor: pointer;
				margin-bottom: Constants.$val-spacing-s;

				&__icon {
					font-size: Constants.$val-fontSizeBig;
					margin-left: Constants.$val-spacing-s;
				}
			}
		}

		&__note {
			background-color: Colors.$col-greyLight;
			padding: Constants.$val-spacing-s;
			margin-top: Constants.$val-spacing-m;
	
			&__edit {
				&__header {
					display: flex;
					justify-content: space-between;
					align-items: center;

					&__button {
						height: 16px;
					}
	
					&__title {
						height: 16px;
						line-height: 16px;
					}

				}
	
				&__text {
					font-weight: bold;
					margin-top: Constants.$val-spacing-m;
				}

			}

			&__add {
				display: flex;
				justify-content: center;
				align-items: center;
			}
	
			&--readonly {
				background-color: Colors.$col-white;
			}
		}
		
	}
}

.cert-status {
	width: fit-content;
}

.cert-status-element {
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	font-weight: 600;
	line-height: Constants.$val-lineHeightSmall;
	font-size: Constants.$val-fontSizeSmall;
	border-radius: Constants.$val-borderRadius;
	background-color: Colors.$col-greyBackground !important;
}

.cert-status-block {
	display: flex;
	align-items: center;
}

.cert-status-tooltip {
	display: flex;
	flex-direction: column;
	align-items: center;
}
